import { Component, OnInit } from '@angular/core';
import { PaginationService } from 'src/app/helpers/pagination.service';
import { ToasterService } from 'src/app/helpers/toastr.service';
import { StocksDetailsService } from './stocks-details.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MyListingService } from '../my-listing/my-listing.service';
import { AddBrandService } from 'src/app/admin/add-brand/add-brand.service';

@Component({
  selector: 'app-stocks-details',
  templateUrl: './stocks-details.component.html',
  styleUrls: ['./stocks-details.component.scss']
})
export class StocksDetailsComponent implements OnInit {

    closeResult = '';
    activeTab = "productListing";
    public export_path:string = '';
    public export_loading:boolean = false;
    public market_place:string = '';
    public category_id:string = '';
    public search_term:string = '';
    public stock_listing_pagination: any = {};
    public stockListing: any = [];
    public current_page: number = 1;
    public offset: number = 0;
    public page_per_view: number = 10;
    config = {
        labelField: 'name',
        valueField: 'value',

    };
    public page_per_view_options = [
        {
            value: 10,
            name: 10
        },
        {
            value: 20,
            name: 20
        }
    ];
    public marketplace_options = [
        {
            value: '',
            name: 'All',
        },
        {
            value: 'wholesale',
            name: 'Wholesale'
        },
        {
            value: 'bulk',
            name: 'Bulk'
        }
    ];
    constructor(
        private modalService: NgbModal,
        private _pageservice: StocksDetailsService,
        private _toastr: ToasterService,
        private _pagination: PaginationService,
        private _mylistingservice: MyListingService,
        private _addbrandservice: AddBrandService
    ) {
        
     }

    ngOnInit(): void {
        this.getproductlistingfilters();
    }

    getproductlistingfilters(){
        this.page_per_view = 10;
        this.offset = 0;
        this.current_page = 1;
        this.getproductlisting();
    }

    getproductlisting() {
        let limit = this.page_per_view;
        let offset = this.offset;
        let current_page = this.current_page;
        let data = { 
            limit: limit,
            offset: offset,
            current_page: current_page,
            search: this.search_term,
            category: this.category_id,
            market_place: this.market_place
        };
        this._pageservice.getdetails(data).subscribe((data) => {
            if (data['status'] == "success") {
                let total_records = data['total_records'];
                this.stock_listing_pagination = this._pagination.getPager(total_records, this.current_page, this.page_per_view);
                this.stockListing = data['searchResults'];
            } else if (data['status'] == "error") {
                this._toastr.error(data['message']);
            }
        });
    }

    getexportfile() {
        this._mylistingservice.exportproductlisting(null).subscribe((data) => {
            if (data['status'] == "success") {
                this.export_path = data['path'];
            } else if (data['status'] == "error") {
                this._toastr.error(data['message']);
            }
        });
    }

    updatestocks(event){
        const file = event.target.files[0];
        let data: any = new FormData();
        data.append('document', file);
        this._mylistingservice.updatestocklisting(data).subscribe((data) => {
            if(data['status'] == "success"){
                this._toastr.success('Stock details has been updated successfully.');
                event.target.value = '';
                this.getproductlistingfilters();
                this.modalService.dismissAll();
            }else if(data['status'] == "error"){
                event.target.value = '';
                this._toastr.error(data['message']);
            }
        });
    }

    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', centered: true, }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    setpage(page) {
        this.current_page = page;
        this.offset = (page - 1) * this.page_per_view;
        this.getproductlisting();
    }

    setpageperview() {
        this.current_page = 1;
        this.getproductlisting();
    }

    keyword = 'name'
    result = [];

    selectEvent(item) {
        this.category_id = item.c_id;
        this.getproductlistingfilters();
    }

    onChangeSearch(val: string) {
        this._addbrandservice.searchcategory({ search: val }).subscribe((data) => {
            if (data['status'] == "success") {
                this.result = data['records'];
            } else if (data['status'] == "error") {
                this._toastr.error(data['message']);
            }
        });
    }

    onFocused(e) {
        // do something when input is focused
    }

}
